/* ############################################################
 * common-app-lp.js
 * ############################################################ */

/* ==========================================================================
   Scroll
   ==========================================================================*/
var scrollEvent = function(){
  $(function(){
    var start_pos = 0,
      header = '#header',
      $header = $(header),
      headerHeight = 105, //ヘッダの高さ
      headerPosition = headerHeight * - 1;

    // headerの固定を解除したい場合は、bodyに「js-no_header_scroll」というクラス名をつける
    var disallowHeaderScroll = $('body').hasClass('js-no_header_scroll');

    /*ページ内＃リンク*/
    $('a.anchor_link').click(function(){
        var href= $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'body' : href);
        var position = target.offset().top-headerHeight; //ヘッダの高さ分位置をずらす
        $("html, body").animate({scrollTop:position}, 300, "swing");
        return false;
    });

    /*ページ外＃リンク*/
    var url = $(location).attr('href');
    if (url.indexOf("?id=") == -1) {
      // スムーズスクロール以外の処理（必要なら）
    } else {
        // スムーズスクロールの処理
      var url_sp = url.split("?id=")
      var hash   = '#' + url_sp[url_sp.length - 1];
      var target2   = $(hash);
      var position2   = target2.offset().top-headerHeight;
      $("html, body").animate({scrollTop:position2}, 300, "swing");
    }
    // 181223 - 作品ページ&作品グループページではない場合に実行
    // bodyに固定解除する判定のクラスがあればheaderの固定を解除
    if (disallowHeaderScroll) {
      $(window).off('scroll.bindScroll');
      $header.addClass('pos_a').removeClass('is-hide');
    } else {
      //headerの表示&非表示
      $(window).on('scroll.bindScroll', function(e){

      	var current_pos = $(this).scrollTop(),
            $searchInputContainer = $('#js-search-input-container'),
            $searchInputContainerTrigger = $('#js-search-input-container-trigger');

        // スクロール量がheaderのheightを下回っていた場合は固定されたままにする
      	if(current_pos < headerHeight){
          $header.removeClass('is-hide');
      	} else if (current_pos > start_pos && current_pos > headerHeight) {
          // スクロール量が0以上なおかつheaderのheightも越えていた場合は固定を解除する
          setTimeout(function() {
            // スクロール量+100pxとロード時のスクロール位置がheaderの高さを越えていてなおかつheaderに非表示にするクラス名がない場合
          	if ($(window).scrollTop() > current_pos + 100 && $(window).scrollTop() > headerHeight && !$header.hasClass('is-hide')) {
              $header.addClass('is-hide');
              // 検索窓が開かれていたら非表示にする。
              if($searchInputContainer.hasClass('is-show')) {
                $searchInputContainer.removeClass('is-show');
                $searchInputContainerTrigger.removeClass('is-show').text('動画検索');
              }
          	}
          },500);
      	} else if(current_pos < start_pos) {
          // スクロール量が0以下の場合は固定解除
          setTimeout(function() {
            // 画面ロードした時のスクロール値+100pxをスクロール量が越えていてなおかつheaderに非表示にするクラス名がある場合
          	if ($(window).scrollTop() + 100 < current_pos && $header.hasClass('is-hide')) {
              if($('.floatingHeader').length || $('.fixed_header_display_none_at_print').length){
                var fixedHeaderExists = false;
                $('.floatingHeader, .fixed_header_display_none_at_print').each(function(){
                  if ($(this).css('visibility') == 'visible') {
                    fixedHeaderExists = true;
                  }
                });
                if (fixedHeaderExists) {
                  return;
                }
              }
              $header.removeClass('is-hide');
          	}
          },500);
      	}
        // スクロール量の値を初期化
      	start_pos = current_pos;
      });
    }
  });

  $(function($){
    $('a.anchor_link02').click(function(){
      var speed = 1000;
      var href= $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top;

      $("html, body").animate({scrollTop:position}, speed, "swing");
      return false;
    });
  });
}

scrollEvent();

/* ==========================================================================
   search
   ==========================================================================*/
$(function() {
  var $headerSearch = $('#js-header-search'),
      $searchInputContainer = $('#js-search-input-container'),
      $searchInputContainerTrigger = $('#js-search-input-container-trigger');

  $headerSearch.submit(function (event) {
    if(! $(this).find('input[name="keyword"]').val()) {
      return false;
    }
  });

  $searchInputContainerTrigger.on('click', function() {
    if(!$(this).hasClass('is-show')) {
      $(this).addClass('is-show').text('とじる');
      $searchInputContainer.addClass('is-show');
    } else {
      $(this).removeClass('is-show').text('動画検索');
      $searchInputContainer.removeClass('is-show');
    }
  });
});

/* ==========================================================================
   各作品モジュールのリンクじゃない部分クリック時の処理
   ==========================================================================*/
$(function(){
    $(document).on('click', '.js-data_link', function() {
      location.href = $(this).data('link');
    });

    // 見たいリストに追加ボタンクリック時は遷移しない
    $(document).on('click', '.btn_keep', function(e) {
      e.stopPropagation();
    });
});

/* ==========================================================================
   グローバルナビ | ブランドリンクの挙動
   ==========================================================================*/
$(function() {
  var $brandLinkTrigger = $('#js-brand-link-trigger'),
      $brandLinkBox = $('#js-brand-link-box');
  var $kuchikomiLinkTrigger = $('#js-kuchikomi-link-trigger'),
      $kuchikomiLinkBox = $('#js-kuchikomi-link-box');
  var $genreLinkTrigger = $('#js-genre-link-trigger'),
      $genreLinkBox = $('#js-genre-link-box');
  var $lineupLinkTrigger = $('#js-lineup-link-trigger'),
      $lineupLinkBox = $('#js-lineup-link-box');

  /* brand */
  $brandLinkTrigger.hover(function() {
    $brandLinkBox.css('visibility', 'visible');
  }, function() {
    $brandLinkBox.css('visibility', 'hidden');
  });

  $brandLinkBox.hover(function() {
    $(this).css('visibility', 'visible');
  }, function() {
    $(this).css('visibility', 'hidden');
  });

  /* kuchikomi */
  $kuchikomiLinkTrigger.hover(function() {
    $kuchikomiLinkBox.css('visibility', 'visible');
  }, function() {
    $kuchikomiLinkBox.css('visibility', 'hidden');
  });

  $kuchikomiLinkBox.hover(function() {
    $(this).css('visibility', 'visible');
  }, function() {
    $(this).css('visibility', 'hidden');
  });

  /* genre */
  $genreLinkTrigger.hover(function() {
    $genreLinkBox.css('visibility', 'visible');
  }, function() {
    $genreLinkBox.css('visibility', 'hidden');
  });

  $genreLinkBox.hover(function() {
    $(this).css('visibility', 'visible');
  }, function() {
    $(this).css('visibility', 'hidden');
  });

  /* lineup */
  $lineupLinkTrigger.hover(function() {
    $lineupLinkBox.css('visibility', 'visible');
  }, function() {
    $lineupLinkBox.css('visibility', 'hidden');
  });

  $lineupLinkBox.hover(function() {
    $(this).css('visibility', 'visible');
  }, function() {
    $(this).css('visibility', 'hidden');
  });
});